import React from 'react';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import { isMobileOnly } from 'react-device-detect';
import { LazyImage } from '../../Components/Common/ImgLoading';

const Game = (props) => {
    const { game, playGame } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let imgUrl = game.images.find((img) => {
        return JSON.parse(img).type == 'banner';
    });

    return (
        <li key={game.game_name} id="casinoListDiv">
            <div className="game-card-wrap">
                <div className="hover-parent" style={{ flexDirection: 'column' }}>
                    <LazyImage image={imgUrl && JSON.parse(imgUrl)?.url} fallbackImage="/images/loading-dark.gif" className="casino-img" />
                    <div className="play-btn" style={{ flexDirection: 'column' }}>
                        <span className="icon-wrap" onClick={() => playGame(game, 'real')}>
                            <i className="far fa-play-circle ico non-hover-ico"></i>
                            <i className="fas fa-play-circle ico hover-ico"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div className="game-text-wrap d-flex justify-content-between ">
                <div className="game-text-left">
                    <h4>{game.game_name}</h4>
                    <p>{game.provider_id}</p>
                </div>
                <div className="info-icon">
                    <Button
                        aria-describedby={id}
                        variant="contained"
                        onClick={handleClick}
                        // onMouseOver={handleClick}
                        // onMouseOut={handleClose}
                    >
                        <img src="/images/info.png" />
                    </Button>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <ul className="game-info">
                            <li>
                                <div>Game Name</div>
                                <div>{game.game_name}</div>
                            </li>
                            <li>
                                <div>Provider</div>
                                <div>{game.provider_name}</div>
                            </li>
                            <li>
                                <div>Volatility</div>
                                <div>{game.volatility_name}</div>
                            </li>
                            <li>
                                <div>Features</div>
                                <div>
                                    {game.features?.map((item, i) => {
                                        let data = JSON.parse(item);
                                        let comma = i == 0 ? '' : ', ';
                                        return comma + data.name;
                                    })}
                                </div>
                            </li>
                            <li>
                                <div>Themes</div>
                                <div>
                                    {game.themes?.map((item, i) => {
                                        let data = JSON.parse(item);
                                        let comma = i == 0 ? '' : ', ';
                                        return comma + data.name;
                                    })}
                                </div>
                            </li>
                        </ul>
                    </Popover>
                </div>
            </div>
        </li>
    );
};

export default Game;
